import React from "react";
import { useHistory } from "react-router-dom";

const SignUpHeader = ({ title, back = false, close = true }) => {
	const history = useHistory();
	const onClickClose = () => {
		history.goBack();
	};
	return (
		<div className={`header together-header-height signup-header`}>
			{back && (
				<img
					onClick={onClickClose}
					src={`/assets/images/go-back.png`}
					alt={`닫기`}
				/>
			)}
			<p>{title}</p>
			{close && (
				<img
					onClick={onClickClose}
					src={`/assets/images/channel/close-icon.png`}
					alt={`닫기`}
				/>
			)}
		</div>
	);
};
export default SignUpHeader;
